import { ExternalLink } from 'lucide-react';

import { Button } from '@/components/ui';
import routes from '@/lib/routes';

type TProps = {
	userId: string;
};

export const UserProfileLinkButton = ({ userId }: TProps) => (
	<Button
		asChild
		variant="outline"
		size="sm"
		className="h-7 px-2 text-xs rounded-full border-blue-200 text-blue-700 hover:bg-blue-50 hover:text-blue-800 hover:border-blue-300 transition-colors"
	>
		<a
			href={routes.nav.users.single.getHref(userId)}
			target="_blank"
			rel="noopener noreferrer"
			aria-label="Voir le profil utilisateur dans un nouvel onglet"
			title="Ouvrir le profil dans un nouvel onglet"
		>
			<span>Profil</span>
			<ExternalLink className="h-3.5 w-3.5 ml-1.5" />
		</a>
	</Button>
);

export default UserProfileLinkButton;
